import {
  DateTimeInput,
  Form,
  required,
  SaveButton,
  SelectInput,
  TextInput,
  useNotify,
  useRecordContext,
  useRedirect,
  useTranslate,
  usePermissions,
  useGetList,
} from 'react-admin';
import {
  Box,
  Card,
  Divider,
  Stack,
  Typography,
  Button as MUIButton,
  Tooltip,
  IconButton,
} from '@mui/material';
import { useEffect, useRef, useState, useMemo, useCallback } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { Permission, PermissionData } from '../../entities/permission.entity';
import { hasPermission } from '../../utils/has-permission';
import useAgentInfo from './useAgentInfo';
import { Resources } from '../resource';

const CreateReferralForm = () => {
  const t = useTranslate();
  const record = useRecordContext();
  return (
    <>
      <Stack spacing={3} gap={2}>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'stretch', sm: 'center' }}
          spacing={2}
          mb={1}
        >
          <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
            {t('module.agentInfo.referredUserId')}
          </Typography>
          <Box sx={{ flexGrow: 1 }}>
            <TextInput label={false} source="referredUserId" validate={[required()]} fullWidth />
          </Box>
        </Stack>
      </Stack>
    </>
  );
};

export default CreateReferralForm;
